<template>
  <div>
    <div class="block">
      <van-form class="creatruleForm" ref="ruleForm" @submit="getOnruleFormSubmit">
        <div class="grey"></div>

        <van-cell center title="基础信息" class="title"> </van-cell>
        <van-field
          class="cellRow"
          label="拍品名称"
          v-model="ruleForm.name"
          maxlength="50"
          name="name"
          required
          placeholder="请输入拍品名称"
          :rules="[{ validator: validatorname, message: messageName }]"
        />
        <!-- 图片上传 -->
        <div class="uploadImage">
          <van-field
            required
            v-model="ruleForm.resourceList"
            name="imageUrl"
            label="拍品图片"
            :rules="[{ required: true, message: '请上传拍品图片' }]"
          >
            <template #input>
              <upload-image
                :imageUrl="imageArr"
                :maxCount="maxCount"
                :width="auto"
                @success="uploadImageSuccess"
                @delete="deleteImage"
              ></upload-image>
            </template>
          </van-field>
          <p class="proposalImage">可上传多张，建议750*750像素或同等</p>
        </div>
        <!-- select -->
        <!-- 拍品分类 -->
        <classification
          :label="label"
          :portraitText="portraitText"
          @portraits="portrait"
          v-model="ruleForm.gradeId"
          :gradeNames="ruleForm.gradeNames"
          @getNames="getNames"
        ></classification>

        <van-cell
          center
          title="更多设置"
          class="title isMore"
          is-link
          @click="isMoreShow(true)"
          :arrow-direction="isMore ? 'down' : ''"
        >
        </van-cell>
        <van-field
          v-show="isMore"
          class="cellRow"
          label="LOT"
          v-model="ruleForm.lot"
          name="lot"
          placeholder="请输入拍品LOT号"
        />
        <van-field
          v-show="isMore"
          class="cellRow"
          label="作者"
          v-model="ruleForm.author"
          name="author"
          placeholder="请输入作者"
          :rules="[{ required: false }]"
        />
        <van-field
          v-show="isMore"
          class="cellRow"
          label="创作年份"
          v-model="ruleForm.year"
          name="year"
          placeholder="创作年份"
          :rules="[{ required: false }]"
        />
        <van-field
          v-show="isMore"
          class="cellRow"
          label="尺寸"
          v-model="ruleForm.size"
          name="size"
          placeholder="尺寸"
          :rules="[{ required: false }]"
        />
        <van-field
          v-show="isMore"
          class="cellRow"
          label="材质"
          v-model="ruleForm.material"
          name="material"
          placeholder="请输入材质"
          :rules="[{ required: false }]"
        />
        <van-field
          v-show="isMore"
          class="cellRow"
          label="形制"
          v-model="ruleForm.padescription"
          name="padescription"
          placeholder="请输入形制"
          :rules="[{ required: false }]"
        />
        <van-field
          v-show="isMore"
          class="cellRow"
          label="工艺"
          v-model="ruleForm.process"
          name="process"
          placeholder="请输入工艺"
          :rules="[{ required: false }]"
        />
        <div class="grey"></div>

        <van-field
          v-show="!ruleForm.liveId"
          required
          class="cellRow"
          v-model="ruleForm.aucStartTime"
          name="aucStartTime"
          label="拍卖开始时间"
          readonly
          placeholder="请输入拍卖开始时间"
          right-icon="arrow"
          @click-right-icon="onGetItem('0')"
          @click="onGetItem('0')"
          :rules="[{ required: !ruleForm.liveId }]"
        />
        <van-popup v-model="showPickerDatetime" position="bottom">
          <van-datetime-picker
            label="拍卖开始时间"
            type="datetime"
            :value="currentDate"
            @confirm="onInput"
            @cancel="showPickerDatetime = false"
          />
        </van-popup>
        <van-field
          v-show="!ruleForm.liveId"
          required
          class="cellRow"
          v-model="ruleForm.aucEndTime"
          name="aucEndTime"
          label="拍卖结束时间"
          readonly
          placeholder="请输入拍卖结束时间"
          @click="onGetItem('1')"
          right-icon="arrow"
          @click-right-icon="onGetItem('1')"
          :rules="[{ required: !ruleForm.liveId }]"
        />
        <van-popup v-model="showPickerDatetime" position="bottom">
          <van-datetime-picker
            label="拍卖结束时间"
            type="datetime"
            :value="currentDateEnd"
            @confirm="onInput"
            @cancel="showPickerDatetime = false"
          />
        </van-popup>
        <div class="leftText">
          <van-field
            required
            class="cellRow"
            label="起拍价"
            v-model="ruleForm.startingPrice"
            name="startingPrice"
            placeholder="请输入起拍价"
            :rules="[{ required: true }]"
          />
          <p>元</p>
        </div>
        <div class="leftText">
          <van-field
            required
            class="cellRow"
            label="保证金"
            v-model.number="ruleForm.marginAmont"
            name="marginAmont"
            type="number"
            placeholder="请输入保证金"
            :rules="[{ required: true }]"
          />
          <p>元</p>
        </div>

        <div class="leftText">
          <van-field
            required
            class="cellRow"
            label="买家佣金"
            v-model="commissionShow"
            name="commission"
            placeholder="请输入买家佣金"
            :rules="[{ required: true }]"
          />
          <p>%</p>
        </div>
        <!-- select -->
        <van-field
          v-show="!ruleForm.liveId"
          required
          class="cellRow iconRight"
          v-model="ruleForm.showPicker"
          left-icon="info-o"
          @click-left-icon="
            portrait(
              '2位2/5/8的竞价阶梯，举例当前价为100元，则后几口价分别为120元、150元、180元、200元、220元，以此类推；固定金额的竞价阶梯，则需填写加价幅度，每次加价可加价固定金额的整数倍；自定义阶梯，需要到plat.zai-art.com后台中设置',
            )
          "
          label="竞价阶梯"
          readonly
          clickable
          name="resolution"
          :value="ruleForm.resolution"
          right-icon="arrow-down"
          @focus="onGetItem('2')"
          @click-right-icon="onGetItem('2')"
          :rules="[{ required: !ruleForm.liveId, message: '请选择竞价阶梯' }]"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="typeArray"
            @confirm="onConfirms"
            @cancel="showPicker = false"
            value-key="name"
            ref="picker"
          />
        </van-popup>

        <div class="leftText" v-show="increaseShow">
          <van-field
            required
            class="cellRow portrait"
            label="加价幅度"
            v-model="ruleForm.sellPrice"
            name="sellPrice"
            placeholder="请输入加价幅度"
            :rules="[{ required: increaseShow }]"
          />
          <p>元</p>
        </div>
        <van-field
          v-show="ruleForm.liveId"
          class="cellRow portrait"
          label="保留价"
          v-model="ruleForm.retainPrice"
          name="retainPrice"
          placeholder="保留价"
        />
        <van-cell
          v-show="!ruleForm.liveId"
          center
          title="更多设置"
          class="title isMore"
          is-link
          :arrow-direction="isMorePrice ? 'down' : ''"
          @click="isMoreShow(false)"
        >
        </van-cell>

        <van-field
          v-show="isMorePrice"
          class="cellRow portrait"
          label="保留价"
          v-model="ruleForm.retainPrice"
          name="retainPrice"
          placeholder="保留价"
        />
        <van-cell center title="估价无底价" v-show="isMorePrice" class="iconCell">
          <van-icon
            name="info-o"
            @click="portrait('设置后不需填写“最高估价”“最低估价”，在“在艺直播”中会显示“无底价”')"
          />
          <van-switch
            v-model="ruleForm.showBasePrice"
            slot="right-icon"
            size="24"
            name="showBasePrice"
            :active-value="true"
            :inactive-value="false"
          />
        </van-cell>
        <van-field
          v-show="isMorePrice && !ruleForm.showBasePrice"
          class="cellRow portrait"
          label="最低估价"
          v-model="ruleForm.aucEvaluationLow"
          name="aucEvaluationLow"
          placeholder="最低估价"
        />
        <van-field
          v-show="isMorePrice && !ruleForm.showBasePrice"
          class="cellRow portrait"
          label="最高估价"
          v-model="ruleForm.aucEvaluationHigh"
          name="aucEvaluationHigh"
          placeholder="最高估价"
        />
        <!-- <van-field
          v-show="isMorePrice"
          class="cellRow portrait"
          label="库存"
          v-model="ruleForm.balanceCount"
          name="balanceCount"
          right-icon="info-o"
          @click-right-icon="portrait('1')"
          placeholder="库存"
        /> -->
        <div class="grey"></div>

        <van-cell center title="物流设置" class="title"> </van-cell>
        <van-cell center title="支持自提" class="iconCell">
          <van-icon
            name="info-o"
            @click="portrait('设置后需填写自提地址，买家购买时可选择“自提”')"
          />
          <van-switch
            v-model="ruleForm.onSite"
            slot="right-icon"
            size="24"
            name="onSite"
            :active-value="true"
            :inactive-value="false"
          />
        </van-cell>
        <van-field
          v-show="ruleForm.onSite"
          class="cellRow portrait"
          label="自提地址"
          v-model="ruleForm.siteAddress"
          name="siteAddress"
          placeholder="自提地址"
          :rules="[{ required: ruleForm.onlySite || ruleForm.onSite }]"
        />
        <van-cell center title="仅自提" v-show="ruleForm.onSite" class="iconCell">
          <van-icon name="info-o" @click="portrait('设置后买家购买时无快递运费，只能选择“自提”')" />
          <van-switch
            v-model="ruleForm.onlySite"
            slot="right-icon"
            size="24"
            name="onlySite"
            :active-value="true"
            :inactive-value="false"
          />
        </van-cell>
        <div
          v-show="
            (!ruleForm.onlySite && !ruleForm.onSite) || !ruleForm.onlySite || !ruleForm.onSite
          "
        >
          <van-cell center title="运费到付">
            <van-switch
              v-model="ruleForm.freightBuyerPay"
              slot="right-icon"
              size="24"
              name="freightBuyerPay"
              :active-value="true"
              :inactive-value="false"
            />
          </van-cell>
          <van-field
            v-show="!ruleForm.freightBuyerPay"
            required
            class="cellRow portrait"
            label="快递运费"
            v-model="ruleForm.freight"
            name="freight"
            placeholder="快递运费"
            :rules="[{ required: ruleForm.freightBuyerPay ? false : true }]"
          />
        </div>
        <div class="grey"></div>
        <van-cell center title="拍品详情" class="title"> </van-cell>
        <van-field
          class="cellRow"
          v-model="ruleForm.goodsDetail"
          type="textarea"
          name="goodsDetail"
          label="请输描述拍品"
        />
        <!-- 图片上传 -->
        <div class="goodsupload">
          <van-field v-model="ruleForm.detail" name="imageUrl" class="goodsImage">
            <template #input>
              <upload-image
                :imageUrl="imgageDetail"
                :maxCount="maxCount"
                width="100%"
                height="auto"
                @success="uploadImageSuccessGoods"
                @delete="deleteImageGoods"
              ></upload-image>
            </template>
          </van-field>
          <p class="proposalImage">添加拍品详情图</p>
        </div>
        <div class="submit">
          <van-button
            block
            type="info"
            native-type="button"
            class="whiteBtn"
            @click="getFormNotSubmit"
            >暂不发布</van-button
          >
          <van-button block type="info" native-type="button" @click="getFormSubmit"
            >立即发布</van-button
          >
        </div>
      </van-form>
    </div>
    <van-popup v-model="isLoading" class="isLoading"> 加载中... </van-popup>
  </div>
</template>
<script>
import uploadImage from '../components/uploadImage';
import { lotCreate, lotView, lotUpdate } from '@/api/lot';
import { formatDateTime, validateKeywords } from '@/utils/index';
import classification from '../components/classification';
import { Toast, Dialog } from 'vant';

export default {
  components: { uploadImage, classification },
  data() {
    return {
      portraitText: '请选择对应的拍品分类，不同的拍品分类会展示在“在艺直播”的不同位置',
      label: '拍品分类',
      isLoading: false,
      maxCount: '20',
      auto: 'auto',
      isMore: false,
      isMorePrice: false,
      ruleForm: {
        liveId: null,
        showPicker: '2位2/5/8',
        resolution: 0,
        goodsDetail: null,
        year: '',
        author: '',
        length: '',
        material: '',
        padescription: '',
        process: '',
        resourceList: [],
        dataGroupInfo: [], // 分组
        imageUrl: '',
        imageWidth: null,
        imageHeight: null,
        name: '',
        sizeUnit: null,
        sizeLength: null,
        sizeWidth: null,
        sizeHeight: null,
        size: '',
        biddingJson: '',
        marginPromiseDy: 30, //保证金违约天数
        commission: 0, //买家佣金,

        readCount: 0, //虚拟围观人数
        startingPrice: null, //起拍价
        retainPrice: 0, //保留价
        marginAmont: null, //保证金
        aucEvaluationLow: 0, //最低估价
        aucEvaluationHigh: 0, // 最高估价
        freight: null, // 运费
        freightBuyerPay: false, // 是否到付
        onSite: false, // 是否自提
        onlySite: false, //仅自提
        siteAddress: '', // 自提地址
        auctionId: null, //专场id
        isPublicAuction: true, //是否上拍
        aucStartTime: null, //拍卖开始时间
        aucEndTime: null, //拍开卖结束时间
        showBidCount: false, // 是否显示出价次数
        showReadCount: false, // 是否显示围观人数
        auctionTo: null,
        attr: {
          subject: '',
          content:
            '<p>如何参加拍卖：</p><p>1、缴纳保证金</p><p>进入拍品详情页，点击右下角[立即竞拍]，缴纳保证金；</p><p>2、出价竞拍</p><p>点击右下角出价，选择或输入相应的价格，确认出价；</p><p>3、竞拍完成</p><p>领先出价并高于保留价时竞得拍品，拍卖页面和系统均有竞拍成功提示；</p><p>4、支付货款</p><p>在个人中心—我的拍卖订单中支付对应货款；</p><p>5、交易完成</p><p>等待物流发货并签收拍品；</p><p><br/></p><p>拍卖规则</p><p>1、竞拍开始后，首次出价须等于或高于起拍价；</p><p>2、每次出价的加价幅度必须是竞价阶梯的整数倍；</p><p>3、用户在拍卖专场内第一次出价前可选择号牌进行匿名出价，选择匿名后一旦出价则直到该专场结束，其匿名状态不可取消，号牌不可更改；同理，不匿名出价后一旦出价也不可再匿名出价；</p><p>4、每次出价最高者者领先，出价低者出局，领先者和出局者均可再次出价；</p><p>5、出价延时：系统规定的拍卖结束时间前5分钟内，如有用户出价，竞拍时间将自动延时5分钟，循环往复至最后5分钟没有用户出价，则拍卖结束；</p><p>6、竞拍结束后，如设置了保留价，最高出价必须大于或等于保留价，否则系统判为流拍；</p><p>7、拍卖结束后用户需在72小时内支付尾款（包括拍品款、买家佣金、物流费用等），如有特殊情况，可联系系统客服；</p><p>8、请出价前仔细阅读拍卖须知，每次出价前需要确认出价，用户一旦竞得拍品，不得撤销出价或拒绝付款，否则将扣除对应拍品保证金；</p><p>9、代理出价：代理出价前需要交纳拍品保证金；其他用户出价超过自己又小于自己给出的代理价格时，系统会代理用户自动按阶梯出价；代理出价每次仅可对一件拍品使用，如果用户对多件拍品代理岀价,则须对每件拍品单独设置；如两名以上用户设置的最高代理价格相同,则出价时间在先的用户优先竞得此件拍品；</p><p>10、其他关于付款、拍品的包装、物流、签收等的约定；</p><p><br/></p><p>名词解释：</p><p>1、起拍价:拍品拍卖开始的起步价格，首次出价须等于或高于起拍价;</p><p>2、保留价:又称拍卖底价，是在拍卖前确定的拍品的最低可售价格，如拍卖结束时最高出价低于保留价，则拍品流拍;</p><p>3、成交价:拍品最终成交的价格，当拍品设置了保留价时，成交价等于或高于保留价;</p><p>4、领先:在竞拍中出价最高者;</p><p>5、出局:在竞拍中出价被其他买家超过，此时可再次出价;</p><p>6、竞得:拍卖结束后出价领先其他买家并高于或等于保留价。</p><p>7、流拍：拍卖结束后，拍品最高出价低于保留价；</p>',
          marginContent:
            '<p>为保证竞拍的公平性，每件拍品都需要缴纳一定金额的保证金做为参拍的凭证，未竞得拍品时，保证金会被退回，竞得拍品并在规定时间内支付尾款的也会退回保证金，竞得拍品未在规定时间内支付尾款的将会扣除对应拍品的保证金。&nbsp;</p><p><br/></p><p>保证金退还的情形：</p><p>1、参拍却未竞得拍品的，在对应拍品拍卖结束后，系统自动原路退还拍品保证金；</p><p>2、参拍并竞得拍品后，在规定时间内支付所有尾款的，系统自动原路退还保证金;</p><p>保证金扣除的情形：竞拍成功，中标者未在规定时间内支付尾款，系统将自动关闭交易并扣除对应拍品的保证金；</p><p>参拍保证金可在【个人中心】--【拍卖保证金】中查看。</p>',
        },
        isTiming: 0, // 是否定时，0 非定时，1定时
        timingReleaseDate: null, // 定时时间
        isSyncAuction: false,
        flagDelete: null,
        showBasePrice: false,
        gradeId: [],
      },
      showPicker: false,
      showTypePicker: false,
      resource: { resourceList: [], detail: [] },
      typeArray: [
        { code: '0', name: '2位2/5/8' },
        { code: '1', name: '固定金额' },
        { code: '2', name: '自定义阶梯' },
      ],
      // 直播类型
      liveType: [
        { code: 0, name: '拍品导购直播' },
        { code: 1, name: '普通导购直播' },
      ],
      minHour: 10,
      maxHour: 20,
      minDate: new Date().getTime(),
      maxDate: new Date(2019, 10, 1).getTime(),
      currentDate: new Date(),
      currentDateEnd: new Date(),
      showPickerDatetime: false,
      pid: null,
      imageArr: [],
      imgageDetail: [],
      isStart: true,
      increaseShow: false,
      commissionShow: null,
    };
  },
  watch: {
    commissionShow(value) {
      let tmp = value || value === 0 ? Number(value) / 100 : null;
      if (tmp) tmp = tmp.toFixed(4);
      this.ruleForm.commission = tmp;
    },
  },
  created() {
    this.init();
  },
  methods: {
    formatDateTime,
    validatorname(value) {
      return value ? !validateKeywords(value) : false;
    },
    messageName(value) {
      if (!value) {
        return '';
      } else {
        return !validateKeywords(value) ? true : validateKeywords(value);
      }
    },
    init() {
      this.ruleForm.liveId = this.$route.query.id || null;
      this.pid = this.$route.params.id;
      this.isEdit = !!this.pid;
      if (this.isEdit) {
        this.editRender();
      }
    },
    // 编辑信息
    editRender() {
      lotView({ id: this.pid }).then(res => {
        console.log('res.data', res);
        Object.assign(this.ruleForm, res.data);
        Object.assign(this.resource.resourceList, res.data.resourceList);
        this.ruleForm.resourceList.map(v => {
          this.imageArr.push(v.imageUrl);
        });
        this.commissionShow = res.data.commission ? res.data.commission * 100 : null;
        // formatDateTime
        this.ruleForm.aucStartTime = formatDateTime(res.data.aucStartTime);
        this.ruleForm.aucEndTime = formatDateTime(res.data.aucEndTime);
        this.ruleForm.gradeId = [
          +res.data.gradeId1 || null,
          +res.data.gradeId2 || null,
          +res.data.gradeId3 || null,
        ];
        if (!this.ruleForm.gradeNames) {
          this.ruleForm.gradeNames = '1';
        }
        // 获取竞价阶梯
        let biddingJson;
        res.data.biddingJson
          ? (biddingJson = JSON.parse(res.data.biddingJson).data)
          : (biddingJson = new Array(0));
        if (biddingJson.length >= 1) {
          if (biddingJson[0].type == '2') {
            this.ruleForm.showPicker = '2位2/5/8';
            this.increaseShow = false;
            this.ruleForm.resolution = 0;
          } else {
            this.ruleForm.showPicker = '固定金额';
            this.increaseShow = true;
            this.ruleForm.sellPrice = biddingJson[0].inputAmount;
            this.ruleForm.resolution = 1;
          }
        } else {
          this.ruleForm.resolution = 2;
          this.increaseShow = false;
          this.ruleForm.showPicker = '其他规格';
        }

        let detailImage;
        //取出详情里的src
        if (res.data.attr['subject']) {
          if (res.data.attr['subject'].indexOf('src') != -1) {
            const url = res.data.attr['subject'].split(/\<img\s*src=\"([^\"]*?)\"[^>]*>/gi);
            for (let i = 0; i < url.length; i++) {
              if (url[i].indexOf('http') != -1) {
                this.imgageDetail.push(url[i]);
                this.resource.detail.push({ imageUrl: url[i] });
              }
            }
          }
          // 取出富文本里的文字
          if (res.data.attr['subject'].indexOf('<p>') != -1) {
            let p = res.data.attr['subject'].split('</p>')[0];
            let isImg = res.data.attr['subject'].split('</p>')[0];
            if (isImg.indexOf('<img') != -1) {
              isImg = isImg.split('<img');
              isImg = isImg[0].split('<p>')[1];
            }
            if (p.indexOf('<p>') != -1 && p.indexOf('<img') != -1) {
              let isp = p.split('<img')[0];
              isp = isp.split('<p>')[1];
              this.ruleForm.goodsDetail = isp;
            } else if (p.indexOf('<p>') != -1) {
              p = p.split('<p>')[1];
              this.ruleForm.goodsDetail = p;
            } else {
              this.ruleForm.goodsDetail = isImg;
            }
          }
        }
      });
    },
    getFormSubmit(value) {
      this.ruleForm.flagDelete = 0;

      // this.ruleForm.isPublicAuction = true;
      this.$refs.ruleForm.submit();
    },
    getFormNotSubmit(value) {
      this.ruleForm.flagDelete = 3;
      // this.ruleForm.isPublicAuction = false;

      this.$refs.ruleForm.submit();
    },
    // 提交
    getOnruleFormSubmit(value) {
      const param = value;
      const imageUrl = this.resource.resourceList[0];
      const oneImage = {
        imageUrl: imageUrl.imageUrl,
        imageHeight: imageUrl.imageHeight,
        imageWidth: imageUrl.imageWidth,
      };
      Object.assign(param, this.ruleForm, this.resource, oneImage);
      param.liveId = this.ruleForm.liveId || null;
      param.startTime = this.currentDate; //销售开始时间
      //商品文字描述和图片描述
      param.attr.subject = '';
      let arrDetail = '';
      if (this.resource.detail) {
        this.resource.detail.map(v => {
          arrDetail += `<img src="${v.imageUrl}"/>`;
        });
      }
      param.attr.subject = `<p>${param.goodsDetail}${arrDetail}</p>`;
      param.gradeId.map((v, index) => {
        let gradeIdIndex = 'gradeId' + (index + 1);
        param[gradeIdIndex] = v;
      });
      if (param.resolution == 0) {
        param.biddingJson = {
          data: [{ min: '0', max: '∞', type: 2, amount: ['2位 2/5/8/0'], inputAmount: '0' }],
        };
      } else {
        param.biddingJson = {
          data: [
            {
              min: '0',
              max: '∞',
              type: 1,
              amount: [`${param.sellPrice}`],
              inputAmount: `${param.sellPrice}`,
            },
          ],
        };
      }
      if (this.ruleForm.liveId) param.biddingJson = ''; //有直播拍下，创建拍品，阶梯为空
      console.log(this.resource);
      console.log(param);
      // 区分编辑/新增
      if (this.isEdit) {
        this.onEdit(param);
      } else {
        this.onAdd(param);
      }
    },
    // 新增
    onAdd(param) {
      this.isLoading = true;
      lotCreate(param)
        .then(res => {
          this.isLoading = false;
          Toast(res.message);
          this.$router.replace('/auction/list');
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    onEdit(param) {
      this.isLoading = true;
      lotUpdate(param)
        .then(res => {
          this.isLoading = false;
          Toast(res.message);
          this.$router.replace('/auction/list');
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    uploadImageSuccessGoods(imageResult) {
      this.resource.detail.push({
        imageUrl: imageResult.imageUrl,
        imageWidth: imageResult.imageWidth,
        imageHeight: imageResult.imageHeight,
      });
    },
    deleteImageGoods(value) {
      this.resource.detail.splice(value.index, 1);
    },
    uploadImageSuccess(imageResult) {
      console.log(imageResult);
      this.resource.resourceList.push({
        imageUrl: imageResult.imageUrl,
        imageWidth: imageResult.imageWidth,
        imageHeight: imageResult.imageHeight,
      });
    },
    deleteImage(value) {
      console.log(value);
      this.resource.resourceList.splice(value.index, 1);
    },
    onConfirm(value, index) {
      console.log(value);
      this.ruleForm.type = value.code;
      this.ruleForm.showTypePicker = value.name;
      this.showTypePicker = false;
    },
    onConfirms(value, index) {
      if (value.code == 1) {
        this.increaseShow = true;
      } else if (value.code == 2) {
        Toast('自定义阶梯，请在电脑端进行处理');
        return;
      }
      console.log(value);
      this.ruleForm.resolution = value.code;
      this.ruleForm.showPicker = value.name;
      this.showPicker = false;
    },
    onGetItem(type) {
      console.log(type);
      this.increaseShow = false;

      if (type == 0) {
        this.isStart = true;
        this.showPickerDatetime = true;
      } else if (type == 1) {
        this.increaseShow = true;
        this.isStart = false;
        this.showPickerDatetime = true;
      } else {
        this.showPicker = true;
      }
    },
    onInput(value) {
      let date = new Date(value);
      if (this.isStart) {
        this.ruleForm.aucStartTime = formatDateTime(date);
      } else {
        this.ruleForm.aucEndTime = formatDateTime(date);
      }
      this.showPickerDatetime = false;
    },
    isMoreShow(type) {
      if (type) {
        this.isMore = !this.isMore;
      } else {
        this.isMorePrice = !this.isMorePrice;
      }
    },
    getNames(value) {
      this.ruleForm.gradeNames = value;
    },
    portrait(message) {
      Dialog({ message });
    },
  },
};
</script>
<style lang="less" scoped>
.block .grey {
  width: 100%;
  height: 10px;
  background: #f8f8f8;
}
.block .title {
  font-size: 16px;
}
.creatruleForm {
  padding-bottom: 80px;
}
.block .isMore {
  font-size: 14px;
  color: #646566;
}
.van-form .submit {
  position: fixed;
  width: 90%;
  left: 50%;
  bottom: 10px;
  border: none;
  max-width: 750px;
  transform: translateX(-50%);
  text-align: center;
}
.van-form .submit .van-button--info {
  background: #222;
  color: #fff;
  border: none;
}
.van-form .proposalImage {
  background: #fff;
  font-size: 12px;
}
.van-form {
  padding-bottom: 60px;
}
/deep/ .van-form .goodsImage {
  overflow: auto;
}
/deep/ .van-form .goodsImage .van-uploader__upload-icon {
  display: none;
}
/deep/ .van-form .goodsImage .van-uploader__upload {
  height: 188px;
  width: 100%;
  background-image: url('../../assets/img/goodsImage.png');
  background-repeat: no-repeat;
  background-size: 30%;
  background-position: center;
}
/deep/ .van-form .goodsImage .van-uploader__preview {
  max-width: 100%;
  margin: 10px;
}
/deep/ .van-form .goodsImage .van-uploader .van-uploader__wrapper {
  flex-wrap: wrap;
}
.van-form .submit .van-button--info {
  display: inline-block;
  width: 45%;
}
.van-form .submit {
  display: flex;
  justify-content: space-around;
}
.van-form .submit .whiteBtn {
  background: #fff;
  border: 1px solid #000;
  color: #222;
}

.van-form .leftText {
  position: relative;
}
.leftText p {
  position: absolute;
  right: 20px;
  top: 12px;
  color: #333;
  font-size: 14px;
}
/deep/ .van-form .leftText .van-field__body {
  padding-right: 20px;
}
/deep/ .isLoading {
  font-size: 14px;
  background: transparent;
  color: #fff;
}
.uploadImage .van-cell::after {
  border: none;
}
.van-form .proposalImage {
  background: #fff;
  font-size: 12px;
  color: #999;
  padding: 10px 16px;
  border-bottom: 1px solid #ebedf0;
}
/deep/ .iconLeft .van-field__body .van-field__right-icon {
  position: absolute;
  left: -2em;
}
/deep/ .iconRight .van-field__left-icon {
  position: absolute;
  left: 5.5em;
}
/deep/ .iconCell .van-cell__left-icon {
  position: absolute;
  left: 5.5em;
}
.goodsupload {
  position: relative;
}
.goodsupload .proposalImage {
  position: absolute;
  bottom: 2em;
  background: transparent;
  width: 100%;
  text-align: center;
  border: none;
}
/deep/ .iconCell .van-cell__value {
  display: block;
  font-size: 16px;
  line-height: inherit;
  position: absolute;
  left: 5.5em;
}
/deep/ .van-form .van-cell,
/deep/ .van-form .van-cell .van-field__label,
/deep/ .iconCell .van-cell__value,
/deep/ .iconLeft .van-field__body .van-field__right-icon {
  color: #323233;
}
</style>
